//ant design
import HeaderSearcher from './HeaderSearcher';
import Vue from 'vue';
Vue.component('suggestions', HeaderSearcher)


function updateFunction (el, binding) {
  $('#header-select2').select2().on("select2:select", (e) => {
    el.dispatchEvent(new Event('change', { target: e.target }));
  });
}

Vue.directive('select', {
  inserted: updateFunction,
  // componentUpdated: updateFunction,
});

new Vue({
    el: '#vue-header',
    data(){
        return {
            keywords: '',
            activity: 0
        }
    },
    mounted() {
        $('#header-select2').select2({
            language: "{{ app()->getLocale() }}",
            placeholder: 'Todos los productos',
            minimumResultsForSearch: -1
        });
    },
    computed:{
        showPopularSearches(){
            return !(this.keywords && this.keywords.length > 0);
        }
    },
    filters: {
        uppercase: function (value) {
          if (!value) return ''
          value = value.toString()
          return value.toUpperCase()
        },
        currency(value) {
          return new Intl.NumberFormat("de-DE",
              {style: "currency", currency: "EUR"}).format(value);
        },
        percentage(value) {
          if(parseInt(value) == parseFloat(value)){
            return parseInt(value) + "%";
          } else {
            return parseFloat(value).toFixed(2) + "%";
          }
        },    
  }
});